import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = process.env.REACT_APP_API_BASE_URL;

export const tripApi = async (data) => {
  let url = "";
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  if (data?.id) {
    url = `${env}${API_ENDPOINT.Trip.api + "/" + data?.id}`;
  } else if(data?.isInvoice) {
    url = `${env}${
      API_ENDPOINT.Trip.api +
      "?type=" +
      data?.type +
      "&status=" +
      data?.status +
      "&isInvoice=" +
      data?.isInvoice +
      "&dateFrom=" +
      (data?.dateFrom ? data?.dateFrom : "") +
      "&dateTo=" +
      (data?.dateTo ? data?.dateTo : "") +
      "&page=" +
      page +
      "&pageSize=" +
      data.pageSize +
      "&search=" +
      (data?.search ? data?.search : "")+
      "&location=" +
      (data?.location ? data?.location : "")
    }`;
  } else {
    url = `${env}${
      API_ENDPOINT.Trip.api +
      "?type=" +
      data?.type +
      "&status=" +
      data?.status +
      "&dateFrom=" +
      (data?.dateFrom ? data?.dateFrom : "") +
      "&dateTo=" +
      (data?.dateTo ? data?.dateTo : "") +
      "&page=" +
      page +
      "&pageSize=" +
      data.pageSize +
      "&search=" +
      (data?.search ? data?.search : "")+
      "&location=" +
      (data?.location ? data?.location : "")
    }`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const sosApi = async (data) => {
  let url = `${env}${API_ENDPOINT.Trip.sosApi}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const cancelTripApi = async (data) => {
  let url = `${env}${API_ENDPOINT.Trip.cancelApi + "/" + data?.id}`;
  const res = await requestInstance.post(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const assignDriverApi = async (data) => {
  let url = "";
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  if (data?.tripId) {
    url = `${env}${
      API_ENDPOINT.Trip.assignDriverApi +
      "?tripId=" +
      data?.tripId +
      "&page=" +
      page +
      "&pageSize=" +
      data.pageSize +
      "&search=" +
      (data?.search ? data?.search : "")
    }`;
  } else {
    url = `${env}${
      API_ENDPOINT.Trip.assignDriverApi +
      "?vehicleId=" +
      data?.vehicleId +
      "&page=" +
      page +
      "&pageSize=" +
      data.pageSize +
      "&search=" +
      (data?.search ? data?.search : "")
    }`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const invoiceApi = async (data) => {
  let url;
  if (data?.magicToken) {
    url = `${env}${
      API_ENDPOINT.Trip.invoiceApi + "?magicToken=" + data?.magicToken
    }`;
  } else {
    url = `${env}${API_ENDPOINT.Trip.invoiceApi + "?tripId=" + data?.id}`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const invoiceDownloadApi = async (data) => {
  const url = `${env}${API_ENDPOINT.Trip.invoiceDownloadApi + "/" + data?.id}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

//migrated ShareTrip Service
export const shareTripApi = async (data) => {
  const { tripId, cid } = data;
  const res = await requestInstance.get(
    `${env}${API_ENDPOINT.Trip.shareTripApi}?tripId=${tripId}&cid=${cid}`,
  )
    .catch((err) => err.response)
  return setCurrentUser(res)
}

export const updateTripStatusApi = async (data) => {
  const url = `${env}${API_ENDPOINT.Trip.apiV3}trip-update-status`;
  const res = await requestInstance.post(url, data).catch((err) => err.response);
  return setCurrentUser(res);
};
